module.exports = __webpack_public_path__ + "img/9-m.28a7d609.jpg";